import { Typography } from "@/components/ui";
import { cn } from "@/lib/utils/cn";
import type { ReactNode } from "react";

type ActionEmptyStateProps = {
  title: string;
  description: string;
  icon?: ReactNode;
  actions?: ReactNode;
  className?: string;
  align?: "left" | "center";
  variant?: "outlined" | "plain";
};

export function ActionEmptyState({
  title,
  description,
  icon,
  actions,
  className,
  align = "center",
  variant = "outlined",
}: ActionEmptyStateProps) {
  const isCentered = align === "center";

  return (
    <div
      className={cn(
        "flex min-h-48 w-full flex-col justify-center px-6 py-10",
        variant === "outlined" &&
          "border-border bg-card/60 rounded-2xl border border-dashed",
        isCentered ? "items-center text-center" : "items-start text-left",
        className,
      )}
    >
      {icon ? (
        <div className="bg-light-primary text-primary mb-4 flex h-12 w-12 items-center justify-center rounded-full">
          {icon}
        </div>
      ) : null}
      <div>
        <Typography variant="heading" className="text-foreground text-lg">
          {title}
        </Typography>
        <Typography
          variant="subHeading"
          className={cn(
            "mt-2 max-w-md text-sm text-balance",
            !isCentered && "max-w-none",
          )}
        >
          {description}
        </Typography>
      </div>
      {actions ? (
        <div
          className={cn(
            "mt-5 flex flex-wrap gap-2",
            isCentered ? "justify-center" : "justify-start",
          )}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}
